import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'Locale';
import { ConfirmationModal } from 'LocalGluons/components/ConfirmationModal';

const FullRecordStorageDialog = ({ onConfirm, onCancel, mode }) => (
    <ConfirmationModal
        header={t('RECORDINGS.FULL_CAPACITY_WARNING_TITLE')}
        confirmLabel={t('COMMON.RECORD')}
        cancelLabel={t('COMMON.CANCEL')}
        message={t('RECORDINGS.FULL_CAPACITY_WARNING_DESCRIPTION')}
        onConfirm={onConfirm}
        onCancel={onCancel}
        mode={mode}
    />
);

FullRecordStorageDialog.defaultProps = {
    mode: 'portrait'
};

FullRecordStorageDialog.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    mode: PropTypes.string
};

export default FullRecordStorageDialog;
